/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![RefreshIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABa0lEQVR4nO1VS0oDQRAdvyCCXkS9QjYGAuZVVcRJVdR1VkKMF8jehXgHEcRjGLyARFwoirpXwU1c+KE0iTGSmZGZjeKDWXRP1Xvd1cWrIPjTCMNwkshWiO2QxM7B+gzRexK7hNg+xCq5XG68Pwdix8TajCVnrgCstyT2GvNdF7ki3bzufiQ5iW51AyF6ArZN5tX5MAynCoW1maVSeY7I6iTa6sWx7QZBMJJIwAlJ9I5Ea41GYzSihGMQ3QDbU0dkO5HAT4GS5Ums3V+6TAU+b52hALxbIh4/tQCxNoeRQ+wotcA/sgeiuoITeEscoloOWXTFV1KtpSYcxMCp20TlxW9BadDniu+G5QbmRuaGNizH/7mrgu3BrSKRgFsuRHdI7KVTrpbbd8euZ/P59WnAFnwPYqe9W5PVkwp8rMkIYldxAwdiNxAtxpeItTnYLT4OIVYm1j2wXfiMANsjsZ5B7ACiy9VqdSKW/FfjDeyADChB8PV7AAAAAElFTkSuQmCC)
 */
export const RefreshIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21 2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h3.93A8 8 0 0 0 6.97 5.78a1 1 0 0 1-1.26-1.56A9.98 9.98 0 0 1 20 6V3a1 1 0 0 1 1-1ZM3 22a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H5.07a8 8 0 0 0 11.96 2.22 1 1 0 1 1 1.26 1.56A9.99 9.99 0 0 1 4 18v3a1 1 0 0 1-1 1Z"
        className={colorClass}
      />
    </svg>
  );
};
